/**
 * Tracks which fulfillment groups the merchant collapsed on a card.
 * Groups start expanded, so the collapsed ids are stored rather than the expanded ones.
 */
import { useCallback, useState } from 'react';

export interface ICollapsedGroups {
    isExpanded: (groupId: string) => boolean;
    toggle: (groupId: string) => void;
}

export function useCollapsedGroups(): ICollapsedGroups {
    const [collapsedIds, setCollapsedIds] = useState<string[]>([]);

    const isExpanded = useCallback(
        (groupId: string) => !collapsedIds.includes(groupId),
        [collapsedIds],
    );

    const toggle = useCallback((groupId: string) => {
        setCollapsedIds((current) => current.includes(groupId)
            ? current.filter((id) => id !== groupId)
            : [...current, groupId]);
    }, []);

    return { isExpanded, toggle };
}

export default useCollapsedGroups;
